<template>
    <nav
        class="guide-builder-side-nav"
        :aria-label="$t('guideBuilderSideNav.Guide builder tools')">
        <pendo-icon-button
            v-for="panel in panels"
            :key="panel.id"
            :icon="panel.icon"
            :tooltip="panel.label"
            :aria-label="panel.label"
            :aria-pressed="String(activePanel === panel.id)"
            :class="['guide-builder-side-nav__button', { 'is-active': activePanel === panel.id }]"
            @click="$emit('panel-change', panel.id)" />
    </nav>
</template>

<script>
import { PendoIconButton } from '@pendo/components';

export default {
    name: 'GuideBuilderSideNav',
    components: {
        PendoIconButton,
    },
    props: {
        activePanel: {
            type: String,
            default: null,
        },
        showChat: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['panel-change'],
    computed: {
        panels () {
            const panels = [];
            if (this.showChat) {
                panels.push({ id: 'chat', icon: 'message-square', label: this.$t('Chat') });
            }
            panels.push({ id: 'inspect', icon: 'sidebar', label: this.$t('Inspect') });

            return panels;
        },
    },
};
</script>

<style lang="less" scoped>
.guide-builder-side-nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px;
    background-color: var(--palette-gray-0);
    border-right: none;
    width: 48px;
    flex-shrink: 0;

    &__button {
        border-radius: 6px;
        color: var(--palette-gray-70);
        margin: 0px;

        &.is-active {
            background-color: var(--palette-gray-20);
            color: var(--palette-gray-100);
        }

        &:hover {
            background-color: var(--palette-gray-20);
        }
    }
}
</style>
